import React from 'react'
import { Icon } from 'gu-ui-kit'
export default {
  initial: {
    status: '',
    referral_link_ids: [],
    query: '',
  },
  configuration: {
    status: {
      subbutton: {
        isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
      },
      icon: (
        <Icon
          name={'checkmark2'}
          size={'s'}
          bgColor={'Label-Confirm'}
          color={'Label-Onsurface'}
        />
      ),
      label: 'referral::referral_clients.filters.dropdown.items.status.label',
      position: 'dropdown',
      type: 'radio group',
      optionLabelPrefix: 'referral::referral_clients.filters.dropdown.items.status.options.',
      options: ['active', 'inactive'],
    },
    referral_link_ids: {
      subbutton: {
        isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
      },
      icon: (
        <Icon
          name={'checkmark2'}
          size={'s'}
          bgColor={'Label-Confirm'}
          color={'Label-Onsurface'}
        />
      ),
      label: 'referral::referral_clients.filters.dropdown.items.referral_link.label',
      position: 'dropdown',
      type: 'checkbox group',
      optionLabelPrefix: 'referral::referral_clients.filters.dropdown.items.referral_link.options.',
      options: [],
    },

    query: {
      subbutton: { isVisible: (value = '') => !!value },
      label: 'referral::referral_clients.filters.input.label',
      placeholder: 'referral::referral_clients.filters.input.label',
      order: 1,
      type: 'input',
    },
  },
}
